import React, {Component} from 'react';
import Menu from "../components/Menu";
import Axios from "axios";
import ApiUrl from "../AppUrl/ApiUrl";
import {toast} from "react-toastify";
import Loading from "../components/Loading";

class EditInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: "",
            id: props.match.params.id,
            title: "",
            des: "",
            img: null,
            loading: true,
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem("admintoken");
        this.setState({ token: token });

        try {
            const res = await Axios.get(ApiUrl.baseurl + "info/" + this.state.id);
            if (res.data) {
                const infoData = res.data.data || res.data;
                this.setState({
                    title: infoData.title || "",
                    des: infoData.des || "",
                    loading: false
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
            toast.error("Failed to load info data");
        }
    }

    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onFileChange = (e) => {
        this.setState({ img: e.target.files[0] });
    }

    onSubmitForm = (event) => {
        event.preventDefault();
        var val = this.state;

        var formData = new FormData();
        formData.append("token", val.token);
        formData.append("title", val.title);
        formData.append("des", val.des);
        if (val.img) {
            formData.append("img", val.img);
        }

        Axios.post(ApiUrl.baseurl + "info/update/" + val.id, formData)
            .then(res => {
                if(res.data.success){
                    toast.success(res.data.success, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTimeout(
                        () => this.props.history.push(`/info`),
                        1000
                    );
                } else {
                    toast.error(res.data.error || "Something went wrong", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(error => {
                console.log(error);
                toast.error(error.response?.data?.error || "Server error occurred");
            });
    }

    render() {
        return (
            <Menu title="Edit Information">
                <h3 className="bg-white title-head"> Edit Information </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.loading === true ?
                                <Loading /> :
                                <form onSubmit={this.onSubmitForm}>
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <label>Title</label>
                                            <input
                                                type="text"
                                                name="title"
                                                required
                                                value={this.state.title}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter title"
                                            />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Description</label>
                                            <textarea
                                                name="des"
                                                required
                                                rows="5"
                                                value={this.state.des}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter description"
                                            />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Image (Optional - Leave blank to keep existing)</label>
                                            <input
                                                type="file"
                                                onChange={this.onFileChange}
                                                className="form-control shadow-none"
                                            />
                                        </div>
                                        <div className="col-md-12 mt-4 mb-5">
                                            <button type="submit" className="btn btn-primary shadow-none">Update</button>
                                        </div>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default EditInfo;